export const EPSILON = 'ε';
export const SIGMA = 'Σ';
export const INTERSECT = '∩';
export const UNION = '∪';